module.exports = __webpack_public_path__ + "static/media/socicon.cae86afb.ttf";